import React, { useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Box, Grid, Stack, Tab, Tabs, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LGTabPanel } from "../../molecules/LGTabPanel";
import { useSnack } from "../../services/SnakbarProvider";
import { useCompany } from "../../contexts/CompanyContext";
import CrudCatalogue from "../../organisms/Catalogues/CrudCatalogue";
import CrudExport from "../../organisms/Exports/CrudExport";

export default function ExportScreen() {
  const [activeTab, setActiveTab] = useState(0);
  const { selectedCompany } = useCompany();
  const { openSnack } = useSnack();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una empresa primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Box
        sx={{
          backgroundColor: "white",
          borderBottom: 1,
          borderColor: "divider",
          position: "fixed",
          zIndex: 99,
          width: "100%",
        }}
      >
        <Tabs value={activeTab} onChange={handleChange}>
          <Tab label={`Exportaciones ${selectedCompany.name}`} />
          <Tab label="Catálogos" />
        </Tabs>
      </Box>

      <LGTabPanel value={activeTab} index={0}>
        <Grid container direction={"row-reverse"} spacing={2}>
          <Grid item xs={12} height={"600px"}>
            <CrudExport companyId={selectedCompany.id} />
          </Grid>
        </Grid>
      </LGTabPanel>

      <LGTabPanel value={activeTab} index={1}>
        <Box sx={{ maxWidth: '800px', margin: '0 auto', mt: 5 }}>
          <Stack spacing={2}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Forwarders</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="EXPORT_FORWARDER" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Tipos de Contenedores</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="EXPORT_CONTAINER_TYPE" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Fracciones Arancelarias</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="TARIFF_FRACTION" nameHeader="Descripción" codeHeader="Fracción" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Destinos</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="EXPORT_DESTINATIONS" />
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">Tipos de Embarque</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <CrudCatalogue catalogueName="EXPORT_SHIPMENT_TYPE" />
              </AccordionDetails>
            </Accordion>
          </Stack>
        </Box>
      </LGTabPanel>
    </DashboardLayout>
  );
}
